import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import InfoField from '../../shared/InfoField';
import Card from '../../shared/Card';
import Select from '../../shared/Select';

const propTypes = {
  defaultLayout: PropTypes.string,
  options: PropTypes.array,
  changeLayout: PropTypes.func,
};

class ReportOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  render() {
    const { defaultLayout, options, changeLayout } = this.props;

    return (
      <Card header="Default Email/Report Options">
        <Row>
          <Col className="mb-4">
            <InfoField editMode={true} label="Default Report Layout">
              <Select value={defaultLayout} options={options} onChange={changeLayout} />
            </InfoField>
          </Col>
        </Row>
      </Card>
    );
  }
}

ReportOptions.propTypes = propTypes;

const mapStateToProps = ({ profile }) => ({
  isSubStandard: profile.isSubStandard,
});

export default connect(mapStateToProps)(ReportOptions);



// WEBPACK FOOTER //
// src/components/reportManagement/ReportOptions/index.jsx